export interface QuickLinksViewInterface {
  quickLinks: Array<{
    Title: string
    LinkUrl: string
    ImagePath: string
    Width?: number
    Height?: number
  }>
}

export const QuickLinksView: React.FunctionComponent<
  QuickLinksViewInterface
> = ({ quickLinks }) => {
  return (
    <section className="flex flex-col sm:flex-row flex-wrap justify-start lg:justify-between">
      {quickLinks &&
        Array.isArray(quickLinks) &&
        quickLinks?.map(({ Title, LinkUrl, ImagePath, Height, Width }, i) => (
          <a
            href={LinkUrl}
            key={String(i)}
            className={`flex items-center my-4 p-2 ${
              i === quickLinks.length - 1 ? 'mr-0' : 'mr-16'
            }`}
          >
            <span className="mr-8">
              <img
                src={ImagePath}
                width={Width ?? 'auto'}
                height={Height ?? 35}
                style={{ minWidth: 35, maxWidth: 40 }}
                aria-label={Title + ' icon'}
              />
            </span>
            <span className="w-full sm:w-48">{Title}</span>
          </a>
        ))}
    </section>
  )
}

export default QuickLinksView
